// extracted by mini-css-extract-plugin
export default {"root":"IsO1Nf7S96urs2YF5jTS","wrap":"pPptoV_z63nErL2uGsJq","body":"OdGOxTWsQyP9dotSkJyt","btn":"U1ijPduRSVZyvNqxk8lz","submitted":"JYI0V4j_K0elaqe1kKQd"};